import { Avatar } from './Avatar.js';

/**
 * The audience, as a face pile.
 *
 * The count is the real number, from the server — listeners are hidden from
 * every client by design, so this is the only place it can come from. The faces
 * are the few we can name; the rest are a tally.
 *
 * It matters because an audio room with an invisible audience feels empty to
 * the performer, which is the opposite of what a full house should feel like.
 */
export function Listeners({ count, known }: { count: number; known: Array<{ sub: string; name: string }> }) {
  if (count === 0) {
    return <p class="t-foot">No one is listening yet.</p>;
  }

  const shown = known.slice(0, 5);
  const rest = count - shown.length;

  return (
    <div class="pile">
      <div class="pile__faces">
        {shown.map((person) => (
          <Avatar key={person.sub} sub={person.sub} name={person.name} size="sm" />
        ))}
        {rest > 0 ? <span class="pile__more">+{rest.toLocaleString()}</span> : null}
      </div>
      <p class="t-foot">
        {count.toLocaleString()} {count === 1 ? 'person' : 'people'} listening
      </p>
    </div>
  );
}
